import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { PaymentMethodInput } from "@/types/payment";

export const usePaymentMutations = (contactId: string) => {
  const [isLoading, setIsLoading] = useState(false);
  const { toast } = useToast();

  const addPaymentMethod = async (paymentData: PaymentMethodInput) => {
    setIsLoading(true);
    try {
      const { error } = await supabase
        .from('payment_methods')
        .insert({
          user_id: contactId,
          ...paymentData,
          updated_at: new Date().toISOString()
        });

      if (error) throw error;

      toast({
        title: "Success",
        description: "Payment method added successfully",
      });
      return true;
    } catch (error) {
      console.error('Error adding payment method:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to add payment method",
      });
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  const deletePaymentMethod = async (id: string) => {
    try {
      const { error } = await supabase
        .from('payment_methods')
        .delete()
        .eq('id', id);

      if (error) throw error;

      toast({
        title: "Success",
        description: "Payment method deleted successfully",
      });
      return true;
    } catch (error) {
      console.error('Error deleting payment method:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "Failed to delete payment method",
      });
      return false;
    }
  };

  return {
    isLoading,
    addPaymentMethod,
    deletePaymentMethod
  };
};